import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { combineReducers, configureStore, createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    title: '',
    confirmText: '',
    confirmTextVisible: true,
    dismissText: '',
    dismissTextVisible: true,
  },
  reducers: {
    setTitle: (state, action) => {
      state.title = action.payload;
    },
    setConfirmText: (state, action) => {
      state.confirmText = action.payload;
    },
    setConfirmTextVisibility: (state, action) => {
      state.confirmTextVisible = action.payload;
    },
    setDismissText: (state, action) => {
      state.dismissText = action.payload;
    },
  },
});

export const reducer = combineReducers({
  modal: modalSlice.reducer,
});

export const store = configureStore({reducer});

export const {
  setTitle,
  setConfirmText,
  setDismissText,
  setConfirmTextVisibility,
} = modalSlice.actions;

export default function Modal(props) {
  const headingText = useSelector(state => state.modal.title);
  const confirmText = useSelector(state => state.modal.confirmText);
  const confirmTextVisible = useSelector(state => state.modal.confirmTextVisible);
  const dismissText = useSelector(state => state.modal.dismissText);
  const dismissTextVisible = useSelector(state => state.modal.dismissTextVisible);
  const modalElement = useRef();

  const {
    children,
    onClickCallback,
    onOpenCallback,
  } = props;

  const [payload, setPayload] = useState({});
  const [clickCallback, setClickCallback] = useState(() => {
    return onClickCallback;
  });

  const closeModal = () => {
    modalElement.current.close();
  }

  const onOpenModal = ({detail}) => {
    if (!detail) {
      return;
    }
    const {payload} = detail;

    modalElement.current.showModal();
    onOpenCallback(payload);
    setPayload(payload);
  };

  const onSetNextCallback = ({detail}) => {
    if (!detail) {
      return;
    }

    const {callback} = detail;
    setClickCallback(() => {
      return callback;
    })
  };

  useEffect(() => {
    document.addEventListener('nv.modal.open', onOpenModal);
    document.addEventListener('nv.modal.set.next-callback', onSetNextCallback);

    return () => {
      document.removeEventListener('nv.modal.open', onOpenModal);
      document.removeEventListener('nv.modal.set.next-callback', onSetNextCallback);
    };
  }, []);

  return (
    <dialog className="nv-modal nv-modal-cozy" id="nv-modal" ref={modalElement}>
      <div className="nv-modal-header">
        <div className="nv-modal-title">{headingText}</div>
        <div className="nv-modal-close-button" onClick={closeModal}/>
      </div>
      <div className="nv-modal-body">{children}</div>
      <div className="nv-modal-footer">
        {dismissTextVisible && <button className="nv-cta-secondary-alt" onClick={closeModal}>{dismissText}</button>}
        {confirmTextVisible && <button className="nv-cta-primary" onClick={() => {
          clickCallback(payload)
        }}>{confirmText}</button>}
      </div>
    </dialog>
  );
}
